import { Component, OnInit } from '@angular/core'

import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http'

import { RequestsService } from '../../../_shared/services/requests.service'

declare var $: any

@Component({
  selector: 'app-send-notifications',
  templateUrl: './send-notifications.component.html',
  styleUrls: ['./send-notifications.component.scss'],
})
export class SendNotificationsComponent implements OnInit {
  page = 1
  count = 10
  public notfiApp: string
  public notfiModule: string
  public notfiTitle: string
  public notfiMessage: string
  public notifiObject: object

  public specificNotification: object

  // selectedFile: File;

  notificationInfos = []

  public res_message: string
  sendSpin = true

  loadNotificationSpin = true
  reloadNotificationSpin = true

  public failedMessage: string
  public singleRecipient: string
  selectedCsv: File = null
  singleContact = true
  // listOfContacts = false;
  messageErrors = false
  messageError: string
  loading = false
  errors = null
  public message: string
  public statusCode = false

  constructor(
    private requestService: RequestsService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    // this.getNotificationMessage()
    this.singleContact = true
    // this.handleChange($);
  }

  showModal(specificNotificationContent): void {
    $('#myModal').modal('show')
    this.specificNotification = specificNotificationContent
  }

  sendModal(): void {
    //do something here
    this.reloadNotificationSpin = false
    this.requestService
      .resendNotification(this.specificNotification)
      .subscribe((res) => {
        this.reloadNotificationSpin = true

        let res_result = res.res_result
        this.res_message = res.res_message

        if (res_result == 'success') {
          this.hideModal()
          console.log(this.res_message)
          this.getNotificationMessage()
        } else if (res_result == 'failed') {
          console.log(this.res_message)
          this.failedMessage = 'Failed to resend, try again'
        } else {
          console.log('nonsense')
        }
      })
  }

  hideModal(): void {
    document.getElementById('close-modal').click()
  }

  // notficationImageChanged(event) {
  //   this.selectedFile = event.target.files[0]
  //   console.log(this.selectedFile)
  // }

  getNotificationMessage() {
    this.loadNotificationSpin = false
    this.requestService.notificationGet().subscribe((res) => {
      this.loadNotificationSpin = true
      this.notificationInfos = res.notifications
      console.log(this.notificationInfos)
    })
  }

  sendNotificationMessage() {
    let notifiObject = {
      to: '/topics/news',
      data: {
        title: this.notfiTitle,
        body: this.notfiMessage,
        click_action: this.notfiModule,
      },
    }

    this.sendSpin = false
    console.log('spin')
    this.requestService
      .postNotification(notifiObject, this.notfiApp)
      .subscribe((res) => {
        console.log('request made')
        this.sendSpin = true
        this.res_message = res.res_message
        let res_result = res.res_result
        if (res_result == 'success') {
          this.notfiApp = ''
          this.notfiModule = ''
          this.notfiTitle = ''
          this.notfiMessage = ''
        } else if (res_result == 'failed') {
          this.sendSpin = true
          this.res_message = res.res_message
        }
      })
  }

  catchError(errorResponse) {
    this.loading = false
    const { error } = errorResponse
    return (this.errors = error.error)
  }

  handleFileSelect($event) {
    this.selectedCsv = $event.target.files[0]
  }

  setList(e: boolean) {
    this.singleContact = e
    console.log(e)
  }

  sendSms() {
    this.loading = true
    const URL = `send_sms`
    let formData = new FormData()
    if (this.message.length === 0) {
      this.messageErrors = true
      this.messageError = 'Provide Message'
    } else {
      if (this.selectedCsv !== null) {
        formData.append('users', this.selectedCsv, this.selectedCsv.name)
        formData.append('message', this.message)
        this.requestService.dash_putWithImage(URL, formData).subscribe(
          (response) => {
            console.log(response)
            this.loading = false
            this.statusCode = true
            this.errors = null
            // this.res_message = 'Success';
            if (response.invalid_nos.length === 0) {
              this.res_message = 'Success'
              this.message = null
              this.selectedCsv = null
            } else {
              this.res_message = 'Invalid Phonenumber(s)'
              const invalid_nos = response.invalid_nos
              this.res_message =
                this.res_message + '\n' + invalid_nos.map((x) => x).join('\n')
            }
            // window.location.reload();
          },
          (error) => {
            // this.catchError(error);
            this.statusCode = false
            // console.log(this.catchError(error));
            this.errors = "There's an issue with your file contents"
          }
        )
      } else {
        formData.append('to', this.singleRecipient)
        formData.append('message', this.message)
        this.requestService.dash_putWithImage(URL, formData).subscribe(
          (response) => {
            console.log(response)
            this.loading = false
            this.statusCode = true
            this.res_message = response.response['Recipients'][0]['status']
            if (this.res_message.toLocaleLowerCase() === 'success') {
              this.singleRecipient = ''
              this.message = null
            }
            // window.location.reload();
          },
          (error) => {
            this.catchError(error)
            this.statusCode = false
          }
        )
      }
    }
  }

  handleChange(evt: any) {
    const target = evt.target
    const elemId = evt.explicitOriginalTarget.id
    console.log(
      'id-value: ',
      document.getElementById(elemId).setAttribute('checked', 'true')
    )
    // document.getElementById(elemId).classList.add(‘focused’);
    if (target.checked) {
      this.singleContact = true
      console.log('tosingleperson')
      // doSelected(target);
      // this._prevSelected = target;
    } else {
      this.singleContact = false
      // doUnSelected(this._prevSelected)
    }
  }
}
